module.exports = __webpack_public_path__ + "static/media/quiz_practice.58011625.png";